const SET = 'patron/session/SET';

export default {
  SET,
};
